<template>
    <div class="animated fadeIn">
     
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
                <b-row>
                    <b-col>
                        <strong> Dashboard</strong> 
                    </b-col>
                    <b-col>
                        <strong style="float: right;"> Date : {{date}} </strong> 
                    </b-col>
                </b-row>
            </div>
            <b-row>
              <b-col md="12" >
                <div id="listloader" v-if="isloader">
              <div class="listloader"></div>
          </div>
        <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">            
          <b-row> 
              <b-col sm="6">
              <b-form-group label="Date Period :"  :label-cols="3" >
                  <date-picker :clearable="false"  name="startdate endate" v-model="time3" :placeholder="['Start date', 'End date']" :input-attr="{ readonly: true }"  :disabled-date="disabledFutureDates" range ></date-picker>
  
  
               </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Shift:"  :label-cols="3" >
                  
                  <b-form-select  v-model="shiftdata" name="status">
                      <option :value="selected" disabled>--Select--</option>
                      <option v-for="pallet in shiftlist" v-bind:value="pallet.shiftname.toLowerCase()">{{ pallet.shiftname}}</option>
                    </b-form-select>
  
              </b-form-group>
            </b-col>
         
            
          </b-row>
          
          <b-row>
            <b-col sm="4" >
              <b-col sm="12">
              
              </b-col>
            </b-col>
             <b-col sm="8" class="my-1 text-right">
              
              <b-form-group>
               <b-button type="submit" size="md" variant="primary" @click="getallchartdata()"> Search</b-button>
             
                <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
             
               
              </b-form-group>
            
            </b-col>
          </b-row>
         
        </b-form> 
  
        <b-row>
          <b-col sm="12">
            <fcclock_attendance v-bind:chartdata="attendancedata" v-bind:shiftdata="shiftdata" v-bind:time3="time3" ></fcclock_attendance>
          </b-col>
          </b-row>
  
          <b-row>
            <b-col sm="6">
              <fcclock_overtimestatus v-bind:chartdata_overtime="overtimedata" v-bind:shiftdata="shiftdata" v-bind:time3="time3" ></fcclock_overtimestatus>
            </b-col>
  
            <b-col sm="6">
              <fcclock_breaktime_exceetedhubwise v-bind:chartdata_breaktime="breaktimedata" v-bind:shiftdata="shiftdata" v-bind:time3="time3"></fcclock_breaktime_exceetedhubwise>
            </b-col>
  
          </b-row>
  
          <b-row>
            <b-col sm="6">
              <fcclock_latelogin_hubwise v-bind:chartdata_latelogin="latelogindata" v-bind:shiftdata="shiftdata" v-bind:time3="time3"></fcclock_latelogin_hubwise>
            </b-col>
            <b-col sm="6">
              <fcclock_singlepunchinhubwise  v-bind:chartdata_singlepunch="singlepunchdata" v-bind:shiftdata="shiftdata" v-bind:time3="time3"></fcclock_singlepunchinhubwise>
            </b-col>
          </b-row>
  
  
          
  
              <!-- <div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item">
                      <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Attendace Overview</a>
                  </li>
  
                    <li class="nav-item">
                      <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Over Time Status</a>
                  </li>  
  
                  <li class="nav-item">
                    <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >Break Time Exceeded Hub-wise</a>
                </li>  
                <li class="nav-item">
                    <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Late Login Hub-wise</a>
                </li>  
                <li class="nav-item">
                    <a @click="activeTab = 4"  class="nav-link" :class="{'active' : isActiveTab(4)}" >Single Punch In Hub-wise</a>
                </li> 
                </ul>
              </div> -->
              
              </b-col>
              <!-- <b-col md="12" >
            
                <div class="tab-panel" v-if="isActiveTab(0)">
                  <fcclock_attendance></fcclock_attendance>
                </div>
    
              <div class="tab-panel" v-if="isActiveTab(1)">
                <fcclock_overtimestatus></fcclock_overtimestatus>
                </div>
                <div class="tab-panel" v-if="isActiveTab(2)">
                  <fcclock_breaktime_exceetedhubwise></fcclock_breaktime_exceetedhubwise>
                </div>  
                <div class="tab-panel" v-if="isActiveTab(3)">
                  <fcclock_latelogin_hubwise></fcclock_latelogin_hubwise>
                </div>  
                <div class="tab-panel" v-if="isActiveTab(4)">
                  <fcclock_singlepunchinhubwise></fcclock_singlepunchinhubwise>
                </div>  
              </b-col> -->
            </b-row> 
          </b-card>
         
        </b-col>
      </b-row> 
    </div>   
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import fcclock_attendance from './fcclock_attendance.vue'
  import fcclock_overtimestatus from './fcclock_overtimestatus.vue'
  import fcclock_breaktime_exceetedhubwise from './fcclock_breaktime_exceetedhubwise.vue'
  import fcclock_latelogin_hubwise from './fcclock_latelogin_hubwise.vue'
  import fcclock_singlepunchinhubwise from './fcclock_singlepunchinhubwise.vue'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  export default {
    data: function() {
      return {
        activeTab: 0,
        fcclock_attendance,
        fcclock_overtimestatus,
        fcclock_breaktime_exceetedhubwise,
        fcclock_latelogin_hubwise,
        fcclock_singlepunchinhubwise,
        date :'',
        time3: [new Date(), new Date()],
        selected:'',
        shiftdata:'1st',
        shiftlist :[],
        attendancedata:[],
        isloader:false,
        overtimedata:[],
        breaktimedata:[],
        latelogindata:[],
        singlepunchdata:[],
        hubid:null,
        User_type:null
      };
    },
    components: {
      fcclock_attendance,
      fcclock_overtimestatus,
      fcclock_breaktime_exceetedhubwise,
      fcclock_latelogin_hubwise,
      fcclock_singlepunchinhubwise,
      DatePicker,
      VueTimepicker
    },
    mounted(){
     var userdata = localStorage.getItem("userData");
     var userInfo = JSON.parse(userdata);
     this.User_type = userInfo.user_type;
     //console.log("userInfo", userInfo);
     this.hubid = userInfo.hub_id
  
      this.disabledFutureDates()
      this.getshiftdata()
      this.getallchartdata()
    },
    created: function() {
      this.isActiveTab(0);
      this.todaydate();
    },
    methods: {
      disabledFutureDates(date) {
        const today = new Date();
       
        today.setHours(0, 0, 0, 0);
      
        return date > today;
        
      },
        isActiveTab(id)
        {
            return this.activeTab === id
        },
        todaydate (){
            var today = new Date();
            this.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            console.log("date",this.date)
        },
        getshiftdata(){
          var Obj = {};
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshiftlist`, Obj)
          .then(result => {
             // this.isBusy = false;
             this.isloader = false
              if (result.body.returnmsg.toLowerCase() === 'successful') {
                this.shiftlist = result.body.returnvalue
              } 
              else {
               this.shiftlist =  []
              }
          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },
        getreportdata(){
      this.isloader = true
      let timerangedata = this.time3
      let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
      let shiftstartdate = timerangedata[0]
      let shiftenddate = timerangedata[1]
  
      var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
      var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";
  
          var Obj = {       
              startdate : fromdate,
              enddate : formatdateto,
              shift : shift,
              hubrbid : this.User_type && this.User_type.toString() == '2' ? this.hubid.toString() : ''
          };
        
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAttendanceoverviewReport`, Obj)
          .then(result => {
             // this.isBusy = false;
             this.isloader = false
              if (result.body.returnmsg.toLowerCase() === 'successful') {
               //    this.getshowbarcharts(result.body.returnvalue)
                  let c = result.body.returnvalue.sort((a, b) => parseInt(b.empcount) - parseInt(a.empcount));

                  this.attendancedata =  c
              } 
              else {
                this.attendancedata = []
              //    let d =  [{
              // "attendance_starttime": "",
              // "attendance_endtime": "",
              // "hubname":"Data Not Found",
              // "empcount": "0"
              // }]
              //  this.getshowbarcharts(d);
              }
          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },
        validateForm(scope) {
         this.errors.clear('form-1')
         this.$validator.validateAll(scope).then((result) => {
             if (result) {
  
             }
         })
     },
        clear(){
        this.starttime = {'HH':'', 'mm':''}
        this.endtime = {'HH':'', 'mm':''}
        this.time3 = [new Date(), new Date()]
        this.shiftdata= '1st'
        this.listdata = []
        this.getallchartdata()
        },
        formatDate: function(date) {
          var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("-");
  
      },
      getallchartdata(){
        this.getreportdata()
        this.getovertimereportdata()
        this.getbreaktimereportdata()
        this.getlateloginreportdata()
        this.getsinglepunchreportdata()
      },
      getovertimereportdata(){
      this.isloader = true
      let timerangedata = this.time3  
      let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
      let shiftstartdate = timerangedata[0]
      let shiftenddate = timerangedata[1]
  
      var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
      var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";
  
          var Obj = {       
              startdate : fromdate,
              enddate : formatdateto,
              shift : shift,
              hubrbid : this.User_type && this.User_type.toString() == '2' ? this.hubid.toString() : ''
  
          };
        
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getOvertimestatusviewReport`, Obj)
          .then(result => {
             // this.isBusy = false;
             this.isloader = false
              if (result.body.returnmsg.toLowerCase() === 'successful') {
                
              let c =result.body.returnvalue.sort((a, b) => parseInt(b.empcount) - parseInt(a.empcount));

              this.overtimedata = c
          
          } 
              else {
                this.overtimedata  = []
     
          }
                   
          })
          .catch(ex => {
              console.log("error-----", ex);
          });
  
  
      },
      getbreaktimereportdata(){
          this.isloader = true
          let timerangedata = this.time3
          let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
          let shiftstartdate = timerangedata[0]
          let shiftenddate = timerangedata[1]
  
          var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
          var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";
      
              var Obj = {       
                  startdate : fromdate,
                  enddate : formatdateto,
                  shift : shift,
                  hubrbid : this.User_type && this.User_type.toString() == '2' ? this.hubid.toString() : ''
  
              };
            
            
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAttendanceBreakExceededReport`, Obj)
              .then(result => {
                 // this.isBusy = false;
                 this.isloader = false
                  if (result.body.returnmsg.toLowerCase() === 'successful') {
                    
                      let c =result.body.returnvalue.sort((a, b) => parseInt(b.empcount) - parseInt(a.empcount));

                      this.breaktimedata = c
                  } 
                  else {
                    this.breaktimedata = []
                  }
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
  
  
      },
      getlateloginreportdata(){
          this.isloader = true
          let timerangedata = this.time3
          let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
          let shiftstartdate = timerangedata[0]
          let shiftenddate = timerangedata[1]
  
          var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
          var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";
      
              var Obj = {       
                  startdate : fromdate,
                  enddate : formatdateto,
                  shift : shift,
                  hubrbid : this.User_type && this.User_type.toString() == '2' ? this.hubid.toString() : ''
  
              };
            
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAttendanceLateloginReport`, Obj)
              .then(result => {
                 // this.isBusy = false;
                 this.isloader = false
                  if (result.body.returnmsg.toLowerCase() === 'successful') {

                    let c =result.body.returnvalue.sort((a, b) => parseInt(b.empcount) - parseInt(a.empcount));

                    this.latelogindata = c
                  
                  } 
                  else {
                    this.latelogindata = []
                   
                  }
                      
          
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
  
  
      },
      getsinglepunchreportdata(){
          this.isloader = true
          let timerangedata = this.time3
          let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
          let shiftstartdate = timerangedata[0]
          let shiftenddate = timerangedata[1]
  
          var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
          var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";
      
              var Obj = {       
                  startdate : fromdate,
                  enddate : formatdateto,
                  shift : shift,
                  hubrbid : this.User_type && this.User_type.toString() == '2' ? this.hubid.toString() : ''
              };
            
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAttendanceSinglepunchReport`, Obj)
              .then(result => {
                 // this.isBusy = false;
                 this.isloader = false
                  if (result.body.returnmsg.toLowerCase() === 'successful') {
                    let c =result.body.returnvalue.sort((a, b) => parseInt(b.empcount) - parseInt(a.empcount));

                  this.singlepunchdata = c
          //             this.statusMap = {};
          //         this.ageGroups = ['Users'];
          //     result.body.returnvalue.forEach(item => {
          //     if (!this.statusMap[item.hubname]) {
          //         this.statusMap[item.hubname] = { };
          //         this.ageGroups.forEach(ageGroup => {
          //             this.statusMap[item.hubname][ageGroup] = 0;
          //         });
          //     }
          //       this.statusMap[item.hubname]['Users'] =  (item.empcount);
       
          //      this.statusMap[item.hubname]['hubid'] =  (item.premiseid);
  
          // });
          //         this.getshowbarcharts(this.statusMap)
  
                  } 
                  else {
                    this.singlepunchdata = []
                  //     let b = {"" : {"Users":0,"hubid":''}}    
                  // this.getshowbarcharts(b);
                  }
                      
          
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
  
  
      },
    }
  };
  </script>
  